<template>
  <div class="rater-wrapper">
    <div
      class="rater-star"
      v-for="(star, index) in stars"
      :key="`RATING_STAR__${index}`"
      :class="{
        active: value > index && value != null,
        disabled: disabled,
        'will-be-active': onMouseOver && localValue >= index ? true : false,
      }"
      @click="setRating(index)"
      @mouseover="starOver(index)"
      @mouseout="starOut(index)"
    >
      <span class="icon"></span>
      <span class="text" v-if="showText">{{ star }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingStar',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    stars: {
      type: [Number, Array],
      default: 5,
    },

    showText: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      localValue: null,
      onMouseOver: false,
    };
  },

  computed: {
    isArrayStars() {
      return Array.isArray(this.stars);
    },
  },

  methods: {
    setRating(index) {
      if (!this.disabled) {
        this.localValue = index;
        this.$emit('input', this.localValue + 1);
      }
    },

    starOver(index) {
      if (!this.disabled) {
        this.localValue = index;
        this.onMouseOver = true;
      }
    },

    starOut() {
      this.onMouseOver = false;
    },
  },
};
</script>
